/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  let spImgList = [
    "https://cdn.shopify.com/s/files/1/0826/4653/2395/files/202410311-p1.png",
    "https://cdn.shopify.com/s/files/1/0826/4653/2395/files/202410311-p2.png",
    "https://cdn.shopify.com/s/files/1/0826/4653/2395/files/202410311-b1.png",
    "https://cdn.shopify.com/s/files/1/0826/4653/2395/files/202410311-b2.png",
    "https://cdn.shopify.com/s/files/1/0826/4653/2395/files/202410311-b3.png",
    "https://cdn.shopify.com/s/files/1/0826/4653/2395/files/202410311-b4.png",
    "https://cdn.shopify.com/s/files/1/0826/4653/2395/files/202410311-d1.png",
    "https://cdn.shopify.com/s/files/1/0826/4653/2395/files/202410311-d2.png",
    "https://cdn.shopify.com/s/files/1/0826/4653/2395/files/202410311-d3.png",
    "https://cdn.shopify.com/s/files/1/0826/4653/2395/files/202410311-d4.png",
    "https://cdn.shopify.com/s/files/1/0826/4653/2395/files/202410311-d5.png",
    "https://cdn.shopify.com/s/files/1/0826/4653/2395/files/202410311-c1.png",
    "https://cdn.shopify.com/s/files/1/0826/4653/2395/files/202410311-c2.png",
    "https://cdn.shopify.com/s/files/1/0826/4653/2395/files/202410311-c3.png",
  ];

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              let scale = document.body.clientWidth / 1080;
              $("#root").css("zoom", scale);
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            262 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();
  new Swiper(".sp-swiper1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 20,
    slidesPerView: 1,
    loop: true,
    pagination: {
      el: ".sp-pagination1",
      clickable: true,
    },
  });
  new Swiper(".sp-swiper3", {
    autoplay: true,
    speed: 6000,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    spaceBetween: 31,
    slidesPerView: "auto",
    loop: true,
  });

  new Swiper("#sp-swiper2", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 0,
    slidesPerView: "auto",
    centeredSlides: true,
    loop: true,
    pagination: {
      el: ".sp-pagination1",
      clickable: true,
    },
  });

  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
  });
  $(".sp-opt").click(function () {
    $(this).addClass("active").siblings().removeClass("active");
    let _index = $(this).index();
    $(".sp-img-p1")[0].srcset = spImgList[_index];
  });
  let colorList = ["Black", "Khaki", "Navy Blue", "Dark Green"];

  // 模拟select
  $(".sp-select").click(function () {
    $(".select-opt").hide();
    $(this).siblings(".select-opt").show();
  });
  $(".select-opt li").click(function () {
    let _swiperIndex = $(this).parents().attr("data-index");
    let _index = $(this).index();
    if (_swiperIndex == 1) {
      $(".sp-img-p2")[0].srcset = spImgList[_index];
    } else {
      $(".sp-img-p3")[0].srcset = spImgList[_index];
    }

    var _text = $(this).html();
    $(this).parent().parent().siblings(".sp-select").html(_text);

    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    $(".select-opt").hide();

    let index1 = $(".select-opt ul[data-index='1']").find('li.active').index()
    let index2 = $(".select-opt ul[data-index='2']").find('li.active').index()
    let produce_index = 1
    if(index1 != index2){
      produce_index = 4
    }else{
      index1 == 0 ? produce_index = 1 : produce_index = 3
    }
    let price = window.product[produce_index].price / 100
    let compare = window.product[produce_index].compare_at_price / 100
    price = (price + '').replace('.', ',')
    compare = (compare + '').replace('.', ',')
    $('.product-box2').find('.price-group .sp-price1').html(price)
    $('.product-box2').find('.price-group .sp-price2').html(compare)
  });
});

$('.sp-opt-wrap div').click(function(){
  let id = $(this).attr('data-id')
  let price = window.product.filter(item=> item.id == id)[0].price / 100
  let compare = window.product.filter(item=> item.id == id)[0].compare_at_price / 100
  price = (price + '').replace('.', ',')
  compare = (compare + '').replace('.', ',')
  $(this).parent().siblings('.price-group').find('.sp-price1').html(price)
  $(this).parent().siblings('.price-group').find('.sp-price2').html(compare)
})

$('.sp-btn-style').click(function(){
  let id = $(this).siblings('.sp-opt-wrap').find('div.active').attr('data-id')
  if(id != undefined){
    let num = $(this).siblings('.addGroup').find('input').val()
    window.location.href = '/cart/' + id + ':' + num
  }else{
    let index1 = $(".select-opt ul[data-index='1']").find('li.active').index()
    let index2 = $(".select-opt ul[data-index='2']").find('li.active').index()
    let produce_index = 1
    if(index1 != index2){
      produce_index = 4
    }else{
      index1 == 0 ? produce_index = 1 : produce_index = 3
    }
    let new_id = window.product[produce_index].id
    let num = $('.product-box2').find('.addGroup input').val()
    window.location.href = '/cart/' + new_id + ':' + num
  }
})